import thunk from "redux-thunk";
import promise from "redux-promise";

import { createStore, applyMiddleware } from "redux";
import reducers from "./reducers/reducers";

const store = createStore(reducers, applyMiddleware(thunk, promise));
export default store;
